"use strict";

import { repeats } from './repeats.js'

const _ = require('lodash')
const d3 = require('d3')

const store = {
  species: {
    table: {
      columns: [
        {
          name: 'MSDBID',
          label: 'MSDB ID',
          sortable: true,
          show: true,
        },
        {
          name: 'OrganismName',
          label: 'Species',
          sortable: true,
          show: true,
        },
        {
          name: 'CommonName',
          label: 'Common Name(s)',
          sortable: true,
          show: true
        },
        {
          name: 'TaxID',
          label: 'Taxonomy ID',
          sortable: false,
          show: false,
        },
        {
          name: 'Kingdom',
          label: 'Kingdom',
          sortable: true,
          show: true
        },
        {
          name: 'Group',
          label: 'Group',
          sortable: true,
          show: true
        },
        {
          name: 'SubGroup',
          label: 'Subgroup',
          sortable: true,
          show: true
        },
        {
          name: 'AssemblyLevel',
          label: 'Assembly Level',
          sortable: false,
          show: false
        },
        {
          name: 'Size',
          label: 'Genome Size (Mb)',
          sortable: true,
          show: true
        },
        {
          name: 'GC',
          label: 'GC%',
          sortable: true,
          show: true,
        },
        {
          name: 'Source',
          label: 'Source',
          sortable: false,
          show: true
        },
        {
          name: 'Build',
          label: 'Build',
          sortable: false,
          show: true
        }
      ],
    },
    initialSelection: "MSDBG000001",
    current: '',
    list: [],
    displayed: [],
    order: ["MSDBG000001"]
  },
  settings: {
    activeIndex: '1',
    showSpeciesPane: [],
    showSpeciesInfo: true,
    loading: false,
    debug: false,
    speciesTablePageSize: 10,
    speciesTablePageSizeOptions: [10, 25, 50, 100, 200],
    speciesTableCurrentPage: 1,
    speciesTableCurrentStart: 0,
    speciesTableCurrentStop: 0,
    speciesTableSortBy: 'MSDBID',
    speciesTableSortDirection: 'asc',
    speciesTableSearchString: '',
    plotUpdateDelayFactor: 200,
    backendBaseURL: 'http://data.ccmb.res.in/msdb/get/backend/',
    downloadBaseURL: 'http://data.ccmb.res.in/msdb/perf/'
  },
  filters: [
    {
      name: 'Kingdom',
      type: 'selection',
      values: [],
      active: false
    },
    {
      name: 'Group',
      type: 'selection',
      values: [],
      active: false
    },
    {
      name: 'SubGroup',
      type: 'selection',
      values: [],
      active: false
    },
    {
      name: 'Size',
      type: 'range',
      values: [0, 10000],
      min: 0,
      max: 10000,
      active: false
    },
    {
      name: 'GC',
      type: 'range',
      values: [0, 100],
      min: 0,
      max: 100,
      active: false
    }
  ],
  info: [],
  repeats: repeats,

  getDisplayedSpecies: function (caller) {
    if (this.settings.debug) {
      console.log(`Displayed Species changed by ${caller}`)
    }
    this.settings.speciesTableCurrentStart = ((this.settings.speciesTableCurrentPage - 1) * this.settings.speciesTablePageSize)
    this.settings.speciesTableCurrentStop = this.settings.speciesTableCurrentStart + this.settings.speciesTablePageSize    
    if (this.settings.debug) {
      console.log(`Displaying species from ${this.settings.speciesTableCurrentStart + 1} to ${this.settings.speciesTableCurrentStop}`)
    }
    this.species.displayed = _.filter(this.species.list, "show").slice(this.settings.speciesTableCurrentStart, this.settings.speciesTableCurrentStop)
  },
  
  sortSpeciesList: function (caller) {
    if (this.settings.debug) {
      console.log(`Species Sort Order changed by ${caller}`)
    }
    if (this.settings.speciesTableSortBy === 'selected') {
      this.species.list = _.orderBy(this.species.list, 'selected', 'desc')
    } else {
      this.species.list = _.orderBy(this.species.list, this.settings.speciesTableSortBy, this.settings.speciesTableSortDirection)
    }
    this.getDisplayedSpecies('Species Sort Function')
  },
  
  addSpecies: async function (row, caller) {
    if (this.settings.debug) {
      console.log(`${row.MSDBID} added to selection by ${caller}`)
    }
    row.selected = true;
    const data = await d3.json(`data/info/${row.MSDBID}_info.json`)
    this.species.order.push(row.MSDBID)
    this.info.push(data.info)
    this.setCurrentSpecies(row.MSDBID, 'addSpecies Function')
  },
  
  removeSpecies: function (row, caller) {
    if (this.settings.debug) {
      console.log(`${row.MSDBID} removed from selection by ${caller}`)
    }
    row.selected = false
    this.species.order.splice(this.species.order.indexOf(row.MSDBID),1)
    _.remove(this.info, s => s.OrgInfo.MSDBID === row.MSDBID)
    if (row.MSDBID === this.species.current) {
      const newCurrentID = this.species.order.length === 0 ? '' : this.species.order[0]
      this.setCurrentSpecies(newCurrentID, 'removeSpecies Function')
    }
  }, 

  searchSpecies: function (caller) {
    if (this.settings.debug) {
      console.log(`Search species function called by ${caller}`)
    }
    this.settings.speciesTableCurrentPage = 1
    this.species.list.forEach(s => 
      s.show = s.OrganismName.toLowerCase().startsWith(this.settings.speciesTableSearchString.toLowerCase()) ||
      s.CommonName.toLowerCase().startsWith(this.settings.speciesTableSearchString.toLowerCase()) ||
      s.OrganismName.toLowerCase().includes(this.settings.speciesTableSearchString.toLowerCase()) ||
      s.CommonName.toLowerCase().includes(this.settings.speciesTableSearchString.toLowerCase())
      )
    this.getDisplayedSpecies('Search function')
  },

  setCurrentSpecies: function (ID, caller) {
    if (this.settings.debug) {
      console.log(`Current Species changed by ${caller}\nCurrent Species set to ${ID}`)
    }
    this.settings.showSpeciesInfo = false
    this.species.current = ID
    _.delay(() => { this.settings.showSpeciesInfo = true }, 300)
  },

  exchangeOrder: function (source, target) {
    if (this.settings.debug) {
      console.log(`Order of species changed`)
    }
    this.species.order[target] = this.species.order.splice(source, 1, this.species.order[target])[0]
  },

  modalTitles: {
    ModalLineLenFrequency: 'Length vs abundance of repeats',
    ModalBarFrequency: 'Frequency of repeats',
    ModalStackAnnoDistribution: 'Genomic distribution of repeats',
    ModalAreaTssDistribution: 'TSS distribution of repeats',
    ModalStackAnnoKmerDistribution: 'Genomic distribution of K-mers'
  },
}

export { store }